import React, { useEffect, useState } from "react";
import { useApi } from "../../../hooks/useApi";
import { loginErrMsgString } from "../../../pages/Login";
import ConfirmBtn from "../../Button/ConfirmBtn";
import LoginInput from "../../Input/LoginInput";
import LoginErrorMessage from "../../Login/LoginErrorMessage";
import AlertModal from "../../Modal/AlertModal";
import DefaultModalLayout from "../../Modal/DefaultModalLayout";
import { LoginInputModalContainer } from "./PwResettingModal";

interface FindPwModalProps {
  closeEvent: () => void;
}

export default function FindPwModal({ closeEvent }: FindPwModalProps) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [isWrong, setIsWrong] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [btnClick, setBtnClick] = useState(false);

  const { response, error } = useApi({
    url: btnClick ? "login/changePW/email" : undefined,
    method: "post",
    data: {
      email,
    },
  });

  console.log(response);

  useEffect(() => {
    if (response?.data?.code === 200) {
      setStep(2);
    } else {
      setIsWrong(true);
      setErrMsg(loginErrMsgString(response?.data?.code, response?.data?.count));
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      setIsWrong(true);
      setErrMsg(error?.message ?? "");
    } else {
      setIsWrong(false);
      setErrMsg("");
    }
  }, [error]);

  return (
    <>
      {step === 1 && (
        <DefaultModalLayout
          isMediumModal={true}
          modalTitle="이메일 확인"
          closeEvent={() => closeEvent()}
          confirmEvent={() => {
            setBtnClick(true);
          }}
          leftBottomBtn={<></>}
          cancelBtn={
            <ConfirmBtn
              btnText="취소"
              btnColor="white"
              btnClickEvent={() => closeEvent()}
            />
          }
          confirmDisabled={email === "" || isWrong}
        >
          <LoginInputModalContainer>
            {/* 새 비밀번호 */}
            <LoginInput
              label="이메일 주소"
              value={email}
              onChangeEvent={(e) => {
                setEmail(e.target.value);

                if (errMsg !== "") {
                  setBtnClick(false);
                  setIsWrong(false);
                }
              }}
              hasError={errMsg !== "" ? true : false}
            />

            {errMsg !== "" && <LoginErrorMessage msg={errMsg} />}
          </LoginInputModalContainer>
        </DefaultModalLayout>
      )}

      {step === 2 && (
        <AlertModal
          title={"임시 비밀번호가 발급되었습니다. 이메일을 확인해 주세요."}
          btnColor="mint"
          customCancelBtn={<></>}
          confirmEvent={() => closeEvent()}
        />
      )}
    </>
  );
}
